const state = {
    auth: {
        permissions: []
    },
}

const getters = {
    getPermissions(state) {
        return state.auth.permissions
    }
}

const actions = {

}

const mutations = {
    setPermissions(state, data) {
        state.auth.permissions = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
